import React, { useEffect, useState, useContext } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import {setPlayerLoanResource } from "../../services/loans.service";
import { SiteVarsContext } from "../../contexts/sitevars-context";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { LoansContext } from '../../contexts/loans-context';
import { LeaderboardContext } from "../../contexts/leaderboard-context";
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";
import { PlayerShirtImage } from "../player/player-shirt-image";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialogActions-root': {
    //padding: theme.spacing(1),
  },
}));

export default function MakeLoanDialogue({open, playerData, auctionListData, handleCloseMakeLoanDialogue}) {
  const {loansData, addLoan} = useContext(LoansContext);
  const teamCodeLookup = {"Arsenal":3, "Aston Villa":7, "Bournemouth":91, "Brentford":94, "Brighton":36, "Chelsea":8, "Crystal Palace":31, "Everton":11, "Fulham":54, "Ipswitch":40, "Leicester":13, "Liverpool":14, "Man City":43, "Man Utd":1, "Newcastle":43, "Nott'm Forest":17, "Southampton":20, "Spurs":6, "West Ham":21, "Wolves":39};
  const { user } = useAuth0();
  const {siteVarsData} = useContext(SiteVarsContext);
  const { getTeamById, getPlayerPositionById } = useSiteVarsFunctions();
  const {leaderboardData} = useContext(LeaderboardContext);
  const clubPlayerIds = new Set();
  leaderboardData.forEach(club => {
    club.players.forEach(player => {
      clubPlayerIds.add(player.playerId);
    });
  });

  //filter out the players which are already loaned by a club
  let filteredAuctionListData = auctionListData
    .filter(player => !loansData.allLoans.some(loan => loan.playerin === player.playerId) && !clubPlayerIds.has(player.playerId))
    .sort((a, b) => {
      if (b.originalCost !== a.originalCost) {
        return b.originalCost - a.originalCost;
      }
      return b.totalPoints - a.totalPoints;
    });

  const handleClose = () => {
    handleCloseMakeLoanDialogue(false);
  };

  const handleMakeLoan = async (playerIn) => {
    //setSiteVarsUpdating(true);
    const clubId = user['https://tlog-online.co.uk/club_id'];
    const windowId = Number(siteVarsData.game_vars.currentWindow);
    const startWeek = Number(siteVarsData.game_vars.currentWeek) + 1;
    await setPlayerLoanResource(clubId, windowId, startWeek, playerIn.playerId, playerData.playerId);
    
    addLoan({clubid: clubId, playerin: playerIn.playerId, playerout: playerData.playerId, startweek: startWeek, windowid: windowId})
    loansData.allLoans.push({clubid: clubId, playerin: playerIn.playerId, playerout: playerData.playerId, startweek: startWeek, windowid: windowId});
    loansData.allLoans.sort((a,b) => b.startweek - a.startweek);
    loansData.clubCount++;
    handleClose();
  };


  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 , lineHeight: 0.8}} id="customized-dialog-title">
          Make Loan<span style={{fontSize:"8pt", color:"#999"}}><br/>Out: {playerData.lastName}</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <TableContainer component={Paper}>
        <Table sx={{ minWidth: 300 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{padding:"10px"}}></TableCell>
              <TableCell padding='none'>Player</TableCell>
              <TableCell sx={{padding:"5px"}}>Cost</TableCell>
              <TableCell sx={{padding:"5px"}}>Total</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredAuctionListData.map((row) => (
              row.positionId == playerData.positionId && row.originalCost <= playerData.originalCost && (
              <TableRow key={row.playerId}>
                <TableCell sx={{padding:"10px"}}><PlayerShirtImage player={row} /></TableCell>
                <TableCell padding='none'><span>{row.lastName}</span>
                  <br />
                  <span style={{fontWeight: 'bold'}}>{getPlayerPositionById(row.positionId).name_short}</span> {getTeamById(row.teamId).name_short}</TableCell>
                <TableCell sx={{padding:"5px"}}>{row.originalCost}</TableCell>
                <TableCell sx={{padding:"5px"}}>{row.totalPoints}</TableCell>
                <TableCell><Button variant="outlined" size="small" onClick={() => {handleMakeLoan(row);}}>Loan</Button></TableCell>
              </TableRow>
              )
            ))}
          </TableBody>
        </Table>
        
      </TableContainer>
      </BootstrapDialog>
    </div>
  );
}